import { useMutation, useQueryClient } from 'react-query'
import { useApplicationCtx } from 'context/application'
import { QueryKeys } from 'common/constants'
import { TAlert, TTagging } from 'interface'
import { tagEvent } from 'utils/tagging'

import Loop from '@interco/icons/core/brands/ic_inter_loop'
import IcCheck from '@interco/icons/core/action-navigation/ic_check'
import { useSnackBar } from '@interco/inter-ui/components/SnackBar'
import { interWbNavigate, IWbHttpData } from '@interco/inter-webview-bridge'
import { TrackData } from '@interco/track'

interface IResponse extends Omit<IWbHttpData, 'response'> {
  response: undefined
}
export default function usePostCheckin({ alert, widget }: { alert: TAlert; widget: string }) {
  const {
    httpHandler,
    userInfo: { account, userType },
    setShowBottomSheet,
  } = useApplicationCtx()
  const queryClient = useQueryClient()
  const { setIsAnimationStopped } = useApplicationCtx()
  const { showSnackBar } = useSnackBar()
  const request = {
    url: '/app/meios-pagamentos/v1/loyalty/daily-check-in',
    method: 'POST',
  }
  return useMutation(
    async (formData: { [key: string]: string | number | undefined }) => {
      TrackData.log({
        url: request.url,
        method: request.method,
        event: 'START_REQUEST',
      })
      return httpHandler.post(request.url, formData, {
        'X-Inter-User-Bank-Account': account,
        // 'X-Inter-User-Identifier': account,
        'X-inter-User-Type': userType,
      }) as Promise<IResponse>
    },
    {
      onSuccess() {
        TrackData.log({
          url: request.url,
          method: request.method,
          event: 'SUCCESS_REQUEST',
        })
        setIsAnimationStopped(false)
        queryClient.invalidateQueries([QueryKeys.CHECKIN_LIST])

        if (widget === 'DAY_7_ENABLED') {
          showSnackBar({
            title: alert.title,
            content: alert.description,
            type: 'DEFAULT',
            hasProgressBar: false,
            customIcon: <Loop fontSize={24} color="white" />,
            buttonLabel: alert.button.text,
            onButtonClick: () => {
              tagEvent({
                type: 'CHECKIN_FLUXO',
                content_action: 'toque',
                ref_type: 'botao',
                action_id: alert.button.text,
              } as TTagging)
              interWbNavigate.openDeepLink(alert.button?.deeplink || '')
            },
          })
        } else {
          showSnackBar({
            title: 'Check-in realizado!',
            type: 'DEFAULT',
            hideButton: true,
            hasProgressBar: false,
            customIcon: <IcCheck width={24} height={24} color="white" />,
          })
        }
      },
      onError(error) {
        setShowBottomSheet(true)
        tagEvent({
          type: 'CHECKIN_ACESSO',
          content_action: 'Dado carregado',
          screen: 'Erro checkin',
          ref_type: 'bottomsheet',
        } as TTagging)
        TrackData.error({
          url: request.url,
          method: request.method,
          event: 'ERROR_REQUEST',
          error: error?.toString(),
        })
      },
    },
  )
}
